// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"6e571f03","281":"43c05c5e","765":"910cdc0b","777":"9b1d87dc","934":"ce39a678"}[chunkId] + ".chunk.js";
};